import React from 'react';

/** Renders translated copy that uses "\n" for deliberate line breaks. */
const Multiline: React.FC<{ text: string }> = ({ text }) => (
  <>
    {text.split('\n').map((line, index) => (
      <React.Fragment key={index}>
        {index > 0 && <br />}
        {line}
      </React.Fragment>
    ))}
  </>
);

export default Multiline;
